import { isNumber } from 'lodash';
import { useEffect, useState } from 'react';

export const useToggleSelection = (
  value?: number | null,
): {
  isSelected: boolean;
  toggleIsSelected: () => void;
} => {
  const [isSelected, setIsSelected] = useState(value === null || isNumber(value));

  useEffect(() => {
    if (value === undefined) {
      setIsSelected(false);
    } else {
      setIsSelected(true);
    }
  }, [value]);

  const toggleIsSelected = () => {
    setIsSelected(!isSelected);
  };

  return {
    isSelected,
    toggleIsSelected,
  };
};
